import $ from 'jquery';




$(document).ready(()=>{

	const $trigger = $('[data-js="resource-trigger"]');

	if($trigger) {
		$trigger.on('click',openResource);
	}
		
})

function openResource() {
	$(this).parents('[data-js="resource"]').addClass('active');
}